export const groupChart = (batch, group) => {
    return batch.reduce((state, event) => {
        state.push(
            group.reduce((s, g, i) => {
                s += `${i ? '-' : ''}${event[g]}`
                return s
            }, '')
        )
        return [...new Set(state)]
    }, [])
}

const addValue = (object, property, value) => {
    if (object.hasOwnProperty(property)) {
        object[property].push(value)
    } else {
        object[property] = []
        object[property].push(value)
    }
}

const chartAttr = ['pointFormat', 'labelPoint']

export const seriesChart = (atrr, events, select, group, categories) => {
    const setAttr = (ev: Event) => {
        return atrr
            .filter(a => chartAttr?.includes(a.replace('__', '')))
            .reduce((state, at) => (ev[at] ? { ...state, [at.replace('__', '')]: ev[at] } : state), {})
    }

    let g = {}
    let dataset = []

    events.map(event => {
        const key = `${event[group]}`
        addValue(g, key, event)
    })

    Object.keys(g).map(key => {
        let data = g[key].map((ev, index) => {
            const { __status } = ev || {}
            let status
            try {
                status = JSON.parse(__status)
            } catch (e) {
                status = __status
            }
            const { __color: color = 'gray' } = status[ev?.status] || {}
            const { timestamp, timestampStart, timestampEnd } = ev || {}
            const timestampLow = g[key][index - 1]?.timestamp || timestamp
            const categoryIndex = categories.indexOf(ev?.[group])

            if (key.includes('__')) {
                return {
                    name: key,
                    x: categoryIndex,
                    dataLabels: {
                        style: {
                            color: 'red'
                        }
                    },
                    ...setAttr(ev)
                }
            }
            if (timestampStart && timestampEnd) {
                return {
                    name: key,
                    x: categoryIndex,
                    low: parseInt(timestampStart) || timestampLow,
                    high: parseInt(timestampEnd) || timestampLow,
                    color: color,
                    ...setAttr(ev)
                }
            } else if (timestampStart && !timestampEnd) {
                return {
                    name: key,
                    x: categoryIndex,
                    low: parseInt(timestampStart) || timestampLow,
                    high: new Date().getTime(),
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 1.5, y2: 0 },
                        stops: [
                            [0, color],
                            [1, 'white']
                        ]
                    },
                    ...setAttr(ev)
                }
            }

            return {
                name: key,
                x: categoryIndex,
                low: timestampLow,
                high: timestamp,
                color: color,
                ...setAttr(ev)
            }
        })

        dataset.push(...data)
    })

    return [
        {
            name: '',
            color: '#795548',
            data: dataset //.filter(function(a) {
                // return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
            // }, Object.create(null))
        }
    ]
}
